// Pure rules behind the relevant / not-relevant marks on Merlin's questions
// (kanban 3709db93), kept out of the components for fast refresh and tests.

import type { RelevanceMark, RelevanceVerdict } from '../../services/roadmapReports';

/** What a click on a verdict button does: pressing the one already chosen clears it. */
export function nextVerdict(mine: RelevanceVerdict | null | undefined, clicked: RelevanceVerdict): RelevanceVerdict | null {
  return mine === clicked ? null : clicked;
}

const shortName = (email: string): string => email.split('@')[0];

/** "relevant: pj, hadi · not relevant: ravi" — who marked it which way, for a tooltip. */
export function marksTitle(marks: readonly RelevanceMark[]): string {
  if (marks.length === 0) return 'Nobody has marked this question yet';
  const yes = marks.filter((m) => m.verdict === 'relevant').map((m) => shortName(m.by));
  const no = marks.filter((m) => m.verdict === 'not_relevant').map((m) => shortName(m.by));
  const parts: string[] = [];
  if (yes.length > 0) parts.push(`relevant: ${yes.join(', ')}`);
  if (no.length > 0) parts.push(`not relevant: ${no.join(', ')}`);
  return parts.join(' · ');
}

/** "67%" for a 0..1 rate; "–" with no marks. */
export function ratePct(rate: number | null | undefined): string {
  if (rate === null || rate === undefined) return '–';
  return `${Math.round(rate * 100)}%`;
}

export type RateTone = 'good' | 'near' | 'low' | 'none';

/** Against Ravi's bar (about 80% relevant): at or above it is good, within ten
 * points is near, below that is low. */
export function rateTone(rate: number | null | undefined, target: number): RateTone {
  if (rate === null || rate === undefined) return 'none';
  if (rate >= target) return 'good';
  if (rate >= target - 0.1) return 'near';
  return 'low';
}
